import { Modal, Row } from 'react-bootstrap'
import variables from '../../Variables.json'
import { useEffect, useState } from 'react'
import api from '../../seller-apis/api'
import { useAlert } from 'react-alert'
import { inputValidations } from '../../Validations/Inputs'

const styles = {
    verifyManifestPopup: {
        headerDiv: {
            display: 'flex',
            width: '100%'
        },
        expTraPriceTag: {
            // background: 'red',
            // width: 'fit-content',
            margin: 'auto',
            // padding: '2px 20px',
            color: 'red',
            // marginBottom: '13px'

        },
        headerBtns: {
            flex: 1,
            border: 'none',
            boxShadow: '0px 1px 0px 0.5px grey',
            padding: '4px 0px',
            fontSize: "14px"
        },
        vtpPara: {
            textAlign: 'left',
            fontSize: '16px',
            fontWeight: "bold",
            padding:"0px 0px 10px 0px"
        },
        imageBox: {
            height: "98px"
        },
        pName: {
            textAlign: 'left',
            fontSize: '16px',
            color: '#165b5b',
            fontWeight:'600'
        },
        sku: {
            textAlign: 'left',
        },
        confirmBtn: {

        },
        label: {
            display: 'flex',
            justifyContent: 'center'
        },
        tpInput: {
            width: "100px",
            padding: '2px 23px 2px 11%',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
        },
        gstInput: {
            fontSize: "10px",
            padding: "2px 10px",
            width: "100px"
        },
        rsLabel: {
            position: 'absolute',
            top: '3px',
            left: '2%',
            // fontWeight:'800 !important'
        },
        tpTitle: {
            color: 'black',
            // sl-758
            width: '40%',
            textAlign: 'right'
        },
        sUpdateContainer: {
            // width: '50%',
            width: '30%',
            textAlign: 'left',
        },
        cStockTitle: {
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: '0px',
            marginLeft: '12px',
            zIndex: 1,
            padding: '0px 4px',
            background: 'white',
        },
        cStockInput: {
            width: "100px",
            padding: '2px 2% 2px 2%',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
        },
        endBtnContainer: {
            textAlign: 'end',
            marginTop: '40px'
        },
        submitBtn: {
            color: '#fff',
            background: '#165b5b',
            borderRadius: '4px',
            padding: "4px 20px",
            borderStyle: 'none',
            fontSize: '15px',
            boxShadow: '0 .2em 1em -.2em #d0d0d0'
        },
        backBtn: {
            color: 'white',
            background: '#909090',
            borderRadius: '4px',
            padding: "4px 15px",
            borderStyle: 'none',
            fontSize: '15px',
            boxShadow: '0 .2em 1em -.2em #d0d0d0',
            marginRight: '4px'
        },
        rejectBtn: {
            color: 'black',
            background: '#FFADB0',
            borderRadius: '4px',
            padding: "4px 15px",
            borderStyle: 'none',
            fontSize: '15px',
            boxShadow: '0 .2em 1em -.2em #d0d0d0',
            marginRight: '4px'
        },
        tpEdit: {
            top: '3px',
            position: 'absolute',
            right: '127px',
            cursor: 'pointer'
        },
        stockEdit: {
            top: '3px',
            position: 'absolute',
            right: '127px',
            cursor: 'pointer'
        },
        hsnInput: {
            width: "100px",
            padding: '2px 2% 2px 2%',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
        },
        hsnEdit: {
            top: '3px',
            position: 'absolute',
            right: '127px',
            cursor: 'pointer'
        },
    }
}

const ActionRequiredConfirmModal = ({ details, callBack, curProp, closeModal, handleReject}) => {
    // Helper to encode all path segments (folders and filename)
    const getEncodedImageUrl = (imgPath) => {
        if (!imgPath) return null;
        const parts = imgPath.split('/');
        const encodedParts = parts.map(segment => encodeURIComponent(segment));
        return `https://s3.toolsvilla.com/${encodedParts.join('/')}`;

    }
    const imageUrl = getEncodedImageUrl(curProp?.image);
    const fallbackImage = null
    const alert = useAlert();
    const [currentStep, setCurrentStep] = useState(0)
    const [tpDisabled, setTpDisabled] = useState(true)
    const [stockDisabled, setStockDisabled] = useState(true)
    const [hsnDisabled, setHsnDisabled] = useState(true)
    const [verTrPrice, setVerTrPrice] = useState(null)
    const [currentStock, setCurrentStock] = useState(null)
    const [hsn, setHSN] = useState("")
    const [gst, setGst] = useState("Select Gst");

    useEffect(() => {
        setGst(details?.vendor?.taxClass)
        setVerTrPrice(details?.vendor?.purchase_price)
        setHSN(details?.vendor?.HSN)
        setCurrentStock(details?.vendor?.stock)
    }, [])

    const handleModalGoBack = (step) => {
        if (step < currentStep) {
            setCurrentStep(step)
        }
    }

    const handlePriceSubmit = () => {
        const isValidStep1 = verManifestValidation.step1()
        if (!isValidStep1) return
        setCurrentStep(2)
    }

    const submitVerifyManifest = async () => {
        const isValidStep2 = verManifestValidation.step2()
        if (!isValidStep2) return;
        let shouldUpdate = false;
        let data = {}
        try {
            // 0
            // let tpData = {}
            // if (currentClickedOrder?.combinationSet?.[0]?.url) {
            //     tpData = {
            //         _id: currentClickedOrder?.productId?._id,
            //         taxClass: gst,
            //         combination: { "url": currentClickedOrder?.combinationSet[0]?.url, "purchase_price": verTrPrice, "sellerWeightChangeSts": "T_PENDING", "stock": currentStock }
            //     }
            // }
            // else {
            //     tpData = {
            //         _id: currentClickedOrder?.productId?._id,
            //         taxClass: gst,
            //         purchase_price: verTrPrice,
            //     }
            // }

            // if (details?.taxClass == gst) {
            //     tpData = {
            //         _id: details?.lead,
            //         purchase_price: verTrPrice,
            //     };
            // } else {
            //     tpData = {
            //         _id: details?.lead,
            //         purchase_price: verTrPrice,
            //         taxClass: gst,
            //     };
            // }
            // tpData["receivedFrom"] = "tv_catalog"

            if (Number(details?.vendor?.HSN) !== Number(hsn)) {
                data["HSN"] = hsn;
                shouldUpdate = true;
            }
            if (Number(details?.vendor?.stock) !== Number(currentStock)) {
                data["stock"] = currentStock;
                shouldUpdate = true;
            }
            if (shouldUpdate) {
                data["_id"] = details?.product?._id
                const res = await api.product.addToExProduct(data)
            }
            callBack("approve", curProp)
            setCurrentStep(0)
        } catch (err) {
            alert.error(err)
        }
    }

    const gstValidationNum = (gst) => {
        if(Number(gst) === 0 || Number(gst) === 5 || Number(gst) === 18){
            return true
        }
        return false
    }



    const verManifestValidation = {
        step1: () => {
            if (verTrPrice === undefined || verTrPrice === null || verTrPrice < 1) {
                alert.info('Transfer price invalid')
                return false;
            }
            if (gst === "" || gst === undefined || gst === null) {
                alert.info('Please enter a valid GST')
                return false;
            }

            if (!gstValidationNum(gst)) {
                alert.info("Please select a valid gst option from 0, 5 or 18")
                return false;
            }   

            if (hsn !== undefined && hsn !== null && hsn !== "") {
                const validation = inputValidations.hsn(hsn);
                if (!validation.status) {
                    alert.info(validation.msg);
                    return false;
                }
            }
            return true;
        },
        step2: () => {
            if (currentStock === undefined || currentStock === null || currentStock < 1 || currentStock === "") {
                alert.info('Please enter a valid stock.')
                return false;
            }
            return true;
        }
    }

    const handleHSNChange = (hsnValue) => {
        // Only allow numeric values for HSN codes (4-8 digits)
        if (/^\d*$/.test(hsnValue) && hsnValue.length <= 8)
            setHSN(hsnValue);
    };


    return (
        <Modal
            show={true}
            className="updtProPopModal orderManVerModal"
            centered
        >
            <Modal.Header>
                {/* SL-758 */}
                <div style={styles.verifyManifestPopup.headerDiv}>
                    <>
                        <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 0 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(0)}>Step 1</button>
                        <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 1 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(1)}>Step 2</button>
                        <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 2 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(2)}>Step 3</button>
                    </>
                </div>
            </Modal.Header>
            <Modal.Body className="updtProPopModal_body p_3px">
                <a class="close mt-1" onClick={() => {
                    closeModal()
                    setCurrentStep(0)
                }}>
                    &times;
                </a>
                <p style={styles.verifyManifestPopup.vtpPara}>{variables.variables.productOpportunitiesOrderTitles[currentStep]}</p>
                <Row className="">
                    <div className="col-md-3 ">
                        {imageUrl ? (
                            <div
                                className="catalog-img-border"
                                style={{
                                    ...styles.verifyManifestPopup.imageBox,
                                    background: `url(${imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                                onError={e => {
                                    e.target.style.background = `url(${fallbackImage})`;
                                }}
                            />
                        ) : (
                            <div
                                className="catalog-img-border"
                                style={{
                                    ...styles.verifyManifestPopup.imageBox,
                                    background: `url(${fallbackImage})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            />
                        )}
                    </div>
                    <div className="col-md-9 py-1">
                        <p className="product-name ff_pop" style={styles.verifyManifestPopup.pName}>{details?.productName}</p>
                        <p className="sku" style={styles.verifyManifestPopup.sku}>{details?.SKU}</p>
                        <p className="sku" style={styles.verifyManifestPopup.sku}>{details?.manufacturerName}</p>
                        {/* ...existing code... */}
                    </div>
                </Row>

                {/* sl- 712 */}
                {/*  Confirm details */}
                {currentStep === 0 && <>
                    <Row className="mt-1 po-details-popup">
                        <div className="" dangerouslySetInnerHTML={{ __html: details?.description }}></div>
                        {details?.descriptionNew && details?.descriptionNew.map((item, index) => {
                            return <><div class="title fs-13 mt-2 bold">{item?.title} : </div><div
                                className="desc fs-13"
                                dangerouslySetInnerHTML={{
                                    __html: item.description,
                                }} />
                                {item?.title == 'Specification' && details?.specificationNew && details?.specificationNew.length > 0 &&
                                    details?.specificationNew && details?.specificationNew.map((item, index) => {
                                        return <><div
                                            className="desc fs-14"
                                        >
                                            <ul className='mb-0'>
                                                <li>
                                                    {item?.type?.name} : {item?.name}{" "}{item?.unit}
                                                </li>
                                            </ul>
                                        </div></>
                                    })
                                }
                            </>
                        })}
                        {!(details?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && details?.specificationNew && details?.specificationNew != "[]" && details?.specificationNew.length > 0 && <>
                            <div>
                                <div class="title fs-14 mb-1 mt-2 bold">Specifications : </div>
                                {details?.specificationNew && details?.specificationNew != "[]" && details?.specificationNew.map((item, index) => {
                                    return <><div
                                        className="desc fs-14"
                                    >
                                        <ul className='mb-0'>
                                            <li>
                                                {item?.type?.name} : {item?.name}{" "}{item?.unit}
                                            </li>
                                        </ul>
                                    </div></>
                                })}
                            </div></>}
                        <div className="pd_desc">
                            <div className="pd_long_desc">Short description</div>
                            <div className='pd_description'>
                                <div id="popupSpecification " dangerouslySetInnerHTML={{ __html: details?.shortDescription }}>
                                </div>
                            </div>
                        </div>
                    </Row>

                    <p style={styles.verifyManifestPopup.endBtnContainer}>
                        <button style={styles.verifyManifestPopup.rejectBtn} onClick={() => handleReject(curProp)}>Reject</button>

                        <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => setCurrentStep(1)}>Confirm and Proceed</button>

                    </p>
                </>}


                {/* Transfer Price Update */}
                {
                    currentStep === 1 && <>
                        <Row className="text-center mt-1">
                            <div className="col-12 ">
                                {/* <div style={styles.verifyManifestPopup.expTraPriceTag}>
                                    Expected Transfer Price : <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(currentClickedOrder?.expTransferPriceFrom)} - <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(currentClickedOrder?.expTransferPriceTo)}
                                </div> */}
                                <form className="">
                                    <label style={styles.verifyManifestPopup.label}>
                                        <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                            Transfer Price (incl. {gst}% GST) :
                                        </span>

                                        <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>
                                            <input
                                                type="number"
                                                autocomplete="off"
                                                minLength="1"
                                                value={verTrPrice}
                                                style={styles.verifyManifestPopup.tpInput}
                                                required
                                                disabled={tpDisabled}
                                                onChange={(e) => setVerTrPrice(e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                            />
                                            <span style={styles.verifyManifestPopup.rsLabel}><i className="bi bi-currency-rupee" style={{ fontWeight: 'bold !important' }}></i></span>
                                            {/* <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setTpDisabled(false)}></i></span> */}
                                        </span>
                                    </label>
                                    <label style={styles.verifyManifestPopup.label}>
                                        <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                            <span className='text-red'>*</span>Select Gst % :
                                        </span>

                                        <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>

                                            <select
                                                size="sm"
                                                style={styles.verifyManifestPopup.gstInput}
                                                value={gst}
                                                onChange={(e) => setGst(e.target.value)}
                                            >
                                                <option value="Select Gst">Select Gst</option>
                                                {variables?.variables?.gstValues.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item}>
                                                            {item}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </span>
                                    </label>
                                    <label style={styles.verifyManifestPopup.label}>
                                        <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                            HSN :
                                        </span>

                                        <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>

                                            <input
                                                type="number"
                                                autocomplete="off"
                                                minLength="1"
                                                value={hsn}
                                                style={styles.verifyManifestPopup.hsnInput}
                                                required
                                                onChange={(e) => handleHSNChange(e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                            />
                                            {/* <span style={styles.verifyManifestPopup.rsLabel}><i className="bi bi-currency-rupee" style={{ fontWeight: 'bold !important' }}></i></span> */}
                                            {/* <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setHsnDisabled(false)}></i></span> */}
                                        </span>
                                    </label>
                                </form>
                            </div>
                        </Row>
                        <p style={styles.verifyManifestPopup.endBtnContainer}>
                            <button style={styles.verifyManifestPopup.rejectBtn} onClick={() => handleReject(curProp)}>Reject</button>

                            <button className='ms-2' style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(0)}>Back</button>
                            <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => handlePriceSubmit()}>Confirm and Proceed</button>
                        </p>
                    </>
                }

                {/* Stock details */}
                {/* sl-758 */}
                {/* Transfer Price Update */}
                {
                    currentStep === 2 && <>
                        <Row className="text-center mt-1">
                            <div className="col-12 ">
                                <form className="">
                                    <label style={styles.verifyManifestPopup.label}>
                                        <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                           <span className='text-red'>*</span>Current Stock :
                                        </span>

                                        <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>
                                            <input
                                                type="number"
                                                autocomplete="off"
                                                minLength="1"
                                                value={currentStock}
                                                style={styles.verifyManifestPopup.cStockInput}
                                                required
                                                onChange={(e) => setCurrentStock(e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                            />
                                            {/* <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setStockDisabled(false)}></i></span> */}
                                        </span>
                                    </label>
                                </form>
                            </div>
                        </Row>
                        <p style={styles.verifyManifestPopup.endBtnContainer}>
                            <button style={styles.verifyManifestPopup.rejectBtn} onClick={() => handleReject(curProp)}>Reject</button>

                            <button className='ms-2' style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(1)}>Back</button>
                            <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => submitVerifyManifest()}>Submit</button>

                        </p>
                    </>
                }
            </Modal.Body>
        </Modal>
    )
}

export default ActionRequiredConfirmModal